export default "__VITE_ASSET__d83477d6__"